import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttachmentModalComponent } from './attachment-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgZorroAntdModule } from 'src/app/modules/nz-zorro-antd.module';
import { NzTableModule } from 'ng-zorro-antd/table';

@NgModule({
  declarations: [AttachmentModalComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NgZorroAntdModule,
    NzTableModule,

  ]
})
export class AttachmentModalModule { }
